import Card from './CardWithTitle'

export default Card
